<div
  class="flex ion-activatable ripple-parent"
  onclick="GLANCE.Cobrowse.Visitor.startSession();"
  >
  <svg attr.width="{{ width }}px"
       attr.height="{{ height }}px"
       viewBox="0 0 30 24"
       xmlns="http://www.w3.org/2000/svg"
       xmlns:xlink="http://www.w3.org/1999/xlink">
    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g id="4a_finizens_menu_boton" transform="translate(-62.000000, -592.000000)">
        <g id="Group-11" transform="translate(24.000000, 582.000000)">
          <g id="Group-3-Copy" transform="translate(38.000000, 9.000000)">
            <g id="Group-12">
              <g id="Group-9" transform="translate(0.000000, 0.695300)">
                <polyline id="Stroke-1" stroke-width="1" class="stroke-on-background"
                          points="20.8511 7.0547 29.1551 7.0547 29.1551 17.3047 9.0741 17.3047 9.0741 7.0547 16.4061 7.0547"
                >
                </polyline>
                <g id="Clip-4"></g>
                <polygon id="Stroke-3" stroke-width="1" class="stroke-on-background"
                         points="9.074 20.476 29.155 20.476 29.155 17.305 9.074 17.305"
                >
                </polygon>
                <polyline id="Stroke-5" stroke-width="1" class="stroke-on-background"
                          points="9.271 12.1523 0.75 12.1523 0.75 1.0543 20.567 1.0543 20.567 12.1523 13.081 12.1523"
                >
                </polyline>
                <polygon id="Stroke-6" stroke-width="1" class="stroke-on-background"
                         points="0.75 15.323 9.073 15.323 9.073 12.152 0.75 12.152"
                >
                </polygon>
                <polygon id="Stroke-7" stroke-width="1" class="stroke-on-background"
                         points="16.472 23.25 22.416 23.25 22.416 20.476 16.472 20.476"
                >
                </polygon>
                <path d="M13.8296,23.25 L24.9276,23.25" id="Stroke-8" stroke-width="1" class="stroke-on-background"
                >
                </path>
              </g>
              <polygon id="Fill-10" points="14.2261 14.75 14.2261 10.747 10.8571 12.749" class="fill-on-background"
              >
              </polygon>
              <polygon id="Fill-11" points="15.7856 5.747 15.7856 9.75 19.1546 7.749" class="fill-on-background"
              >
              </polygon>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
  <ng-content></ng-content>
  <ion-ripple-effect></ion-ripple-effect>
</div>
